export const EASE = {
  luxury: 'power4.out',
  cinematic: 'expo.out',
  smooth: 'power3.out',
  entrance: 'power2.out',
  bounce: 'back.out(1.2)',
};

export const BEZIER = {
  luxury: [0.16, 1, 0.3, 1],
  cinematic: [0.77, 0, 0.175, 1],
  soft: [0.22, 1, 0.36, 1],
};

export const DURATION = {
  fast: 0.4,
  normal: 0.7,
  slow: 1.1,
  reveal: 0.9,
};
